export enum ShowHeaderType {
  None,
  Info,
  Bar,
}
